import { matchPath } from 'react-router';

import { dangerouslyHideApplicationUI } from '@adminhub/utilities/application';

import { ROOT_ROUTES } from './async/top-routes';

// eslint-disable-next-line @typescript-eslint/no-floating-promises
(async function preload() {
	const currentURL = window?.location?.pathname;

	// PRE REACTIONS
	// - growth need to hide site admin loading (#SUPERNOVA-267)
	// - Growth ticket (https://hello.atlassian.net/browse/PBAU-45)
	// PC Ticket - https://hello.atlassian.net/browse/PC-12359
	// this is done to smooth out the experience for user
	// the user in growth exp should only see either white screen or opened focusedTask
	if (
		matchPath(
			{
				path: '/s/:cloudId/upflow/paymentdetails',
			},
			currentURL,
		)
	) {
		dangerouslyHideApplicationUI();
	}

	// find top match
	// TODO: what if more that one?
	const topMatch = Object.keys(ROOT_ROUTES).filter((route) => {
		const routeConfig = ROOT_ROUTES[route];
		const pattern = {
			path: route,
			// In React Router v6, routes are exact by default (end: true).
			// The `exact` option from v5 is removed. Use `end: false` for non-exact matching.
			// If routeConfig.exact is false, we want non-exact matching (end: false)
			// Otherwise, use default exact matching (end: true or omit it)
			...(routeConfig?.exact === false ? { end: false } : {}),
		};

		return matchPath(pattern, currentURL);
	})[0];

	if (topMatch === undefined) {
		return;
	}
	/* eslint-disable  no-console */

	const blockName = `🚛 preloading ${topMatch}`;
	console.time(blockName);
	try {
		// Loadable has broken definitions
		await (ROOT_ROUTES[topMatch].importer as any).preload();
	} finally {
		console.timeEnd(blockName);
	}

	/* eslint-enable */
})();
